howspace.widgets.live = (() => {
    'use strict';

    const livePopoutLayout = $('.live-popout-layout');
    const main = $('#main');
    let drag = false;
    let dragInitialized = false;

    const updateUsers = widget => {
        const showMoreBtn = widget.find('.show-more-btn');
        const userCount = widget.find('.users .avatar-container').length;
        const userLimit = 3; // this is defined also in view-content.phtml and live.css

        if (userCount > userLimit) {
            showMoreBtn.removeClass('d-none');
        } else {
            showMoreBtn.addClass('d-none');
        }

        const moreUserCount = userCount - userLimit;
        const moreUserText = showMoreBtn.data('text');

        showMoreBtn.find('.btn-text').html(moreUserCount + ' ' + moreUserText);
    };

    // --- Cross-tab coordination ------------------------------------------------
    // "In a meeting" lives in the shared PHP session, so every tab of the same
    // browser server-renders the Whereby iframe on load. Left uncoordinated, each
    // tab would join Whereby and register presence on its own — duplicating the
    // user both in the call and in the participant list. We let a single tab own
    // the live call; other tabs show a notice and can take it over on demand.
    const liveTabSync = (() => {
        const channel = ('BroadcastChannel' in window) ? new BroadcastChannel('howspace-live') : null;
        const tabId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Math.random());
        let isOwner = false;
        // Detached iframe markup, kept so a deferring tab can spin the call up later.
        let pendingEmbed = null;

        const notice = () => livePopoutLayout.find('.live-popout-other-tab-notice');
        const hideNotice = () => notice().addClass('d-none');
        const showNotice = () => {
            livePopoutLayout.find('iframe').remove();
            notice().removeClass('d-none');
            livePopoutLayout.removeClass('d-none');
        };
        const post = msg => channel && channel.postMessage(msg);

        // Stop owning the call locally without ending the meeting (the session
        // stays active). Removing the iframe leaves the Whereby room; the
        // unsubscribe drops our presence so the duplicate avatar disappears.
        const release = () => {
            if (!isOwner) {
                return;
            }
            isOwner = false;
            const iframe = livePopoutLayout.find('iframe');
            if (iframe.length) {
                pendingEmbed = iframe[0].outerHTML;
            }
            const topic = livePopoutLayout.data('widget-topic');
            if (topic) {
                real.realtime.unsubscribe(topic);
            }
            showNotice();
            howspace.activityTracker.setInMeeting(false);
        };

        if (channel) {
            channel.addEventListener('message', e => {
                const msg = e.data || {};
                if (msg.type === 'ping') {
                    // Answer load-time probes so a new tab knows the call is taken.
                    if (isOwner) {
                        post({ type: 'present' });
                    }
                } else if (msg.type === 'claim') {
                    // Another tab took the call; step down here.
                    release();
                } else if (msg.type === 'left') {
                    // The meeting ended in another tab; mirror that teardown here.
                    isOwner = false;
                    const widgetId = livePopoutLayout.attr('data-widget-id');
                    hideNotice();
                    howspace.widgets.live.destroyPopout();
                    if (widgetId) {
                        const widget = $('#widget-' + widgetId);
                        if (widget.length) {
                            howspace.widgets.updateWidget(widget, 'view');
                        }
                    }
                    howspace.activityTracker.setInMeeting(false);
                }
            });
        }

        return {
            // Page-load decision for a server-rendered active popout: keep the
            // call in this tab unless another tab is already running it.
            adopt: () => {
                const iframe = livePopoutLayout.find('iframe');
                if (iframe.length === 0) {
                    return; // No meeting was restored.
                }
                if (!channel) {
                    isOwner = true; // No coordination available; behave as before.
                    return;
                }

                // Detach the iframe right away so it can't join Whereby before we
                // know whether another tab already owns the call.
                pendingEmbed = iframe[0].outerHTML;
                iframe.remove();

                let ownerExists = false;
                let yieldToOther = false;
                const onProbe = e => {
                    const m = e.data || {};
                    if (m.type === 'present') {
                        ownerExists = true;
                    } else if (m.type === 'ping' && m.tabId && m.tabId < tabId) {
                        // A competing fresh tab with priority (lowest id wins) so
                        // simultaneous reloads don't both claim the call.
                        yieldToOther = true;
                    }
                };
                channel.addEventListener('message', onProbe);
                post({ type: 'ping', tabId: tabId });

                setTimeout(() => {
                    channel.removeEventListener('message', onProbe);
                    if (ownerExists || yieldToOther) {
                        showNotice();
                    } else {
                        isOwner = true;
                        hideNotice();
                        livePopoutLayout.append(pendingEmbed);
                        pendingEmbed = null;
                    }
                }, 300);
            },

            // This tab is now running the call (explicit join). Tell any other
            // owner to step down so the user only ever joins once.
            claim: () => {
                isOwner = true;
                hideNotice();
                post({ type: 'claim' });
            },

            // "Move here": pull the call into this tab from whichever tab owns it.
            takeOver: () => {
                post({ type: 'claim' });
                isOwner = true;
                hideNotice();
                if (livePopoutLayout.find('iframe').length === 0) {
                    if (pendingEmbed) {
                        livePopoutLayout.append(pendingEmbed);
                        pendingEmbed = null;
                    } else {
                        // No cached embed to restore; reload to re-render it.
                        window.location.reload();
                    }
                }
            },

            // The meeting ended in this tab; let the other tabs tear down too.
            broadcastLeft: () => {
                isOwner = false;
                post({ type: 'left' });
            },
        };
    })();

    // Decide ownership for a meeting that was restored on page load.
    liveTabSync.adopt();

    // User subscribed event.
    real.events.on('widget:live:user_subscribed', notification => {
        const widget = $('#widget-' + notification.object.widget.id);

        if (widget.length === 0) {
            // Widget not found.
            return;
        }

        const usersWrapper = widget.find('.users-wrapper');
        const users = usersWrapper.find('.users');
        // The avatar arrives as server rendered HTML in its loading state. Without an init the picture component
        // never observes it, so it stays on the blurred placeholder and spinner.
        const avatar = $(notification.object.user.avatar);
        users.prepend(avatar);
        howspace.components.init(avatar);

        if (users.find('.avatar-container').length === 1) {
            usersWrapper.removeClass('d-none');
            howspace.animate(usersWrapper, 'slideDown', 350);
        }

        updateUsers(widget);
    });

    // User unsubscribed event.
    real.events.on('widget:live:user_unsubscribed', notification => {
        const widget = $('#widget-' + notification.object.widget.id);

        if (widget.length === 0) {
            // Widget not found.
            return;
        }

        const usersWrapper = widget.find('.users-wrapper');
        const users = usersWrapper.find('.users');
        if (users.find('.avatar-container').length === 1) {
            howspace.animate(usersWrapper, 'slideUp', 350, () => {
                usersWrapper.removeAttr('style').addClass('d-none');
            });
        }

        users.find('.avatar[data-user-id=' + notification.object.user.id + ']').remove();
        updateUsers(widget);
    });

    // Whereby iframe message event.
    window.addEventListener('message', function(event) {
        // Ignore if event is not from trusted origin
        if (event.origin !== real.dom.$html.data('whereby-uri')) {
            return;
        }

        const widgetId = livePopoutLayout.attr('data-widget-id');
        if (!widgetId) {
            return;
        }

        // Register presence only once Whereby confirms the local user has actually
        // entered the room. Clicking Join loads the iframe, but the user may still
        // bail out in the pre-call screen, be refused entry to a locked/full room,
        // or fail to load the iframe. Subscribing here (instead of on Join click)
        // keeps the participant list in sync with who is genuinely in the call.
        if (event.data.type === 'join') {
            const topic = livePopoutLayout.data('widget-topic');
            if (topic) {
                real.realtime.subscribe(topic);
            }
            return;
        }

        if (event.data.type === 'leave') {
            const widget = $('#widget-' + widgetId);
            howspace.widgets.live.leave(widget);
        }
    });

    // "Move here" pulls an active call into this tab from the tab that owns it.
    livePopoutLayout.find('.move-here-btn').on('click', () => liveTabSync.takeOver());

    // Dismiss the "in another tab" notice locally, freeing up the page in this
    // tab. The meeting keeps running in whichever tab owns it. A page reload
    // re-evaluates ownership and can bring the notice back.
    livePopoutLayout.find('.close-notice-btn').on('click', () => {
        howspace.fullscreen.close(livePopoutLayout);
        real.dom.$body.removeClass('live-active');
        $('#main').removeClass('live-popout-right live-popout-top live-popout-bottom');
        livePopoutLayout.addClass('d-none');
    });

    livePopoutLayout.find('.position-btn').on('click', e => {
        const btn = $(e.target);
        const dropdown = btn.closest('.dropdown');
        howspace.components.dropdown.close(dropdown);

        const widgetId = livePopoutLayout.attr('data-widget-id');
        const widget = $('#widget-' + widgetId);

        const position = btn.data('position');
        const main = $('#main');
        main.removeClass('live-popout-right live-popout-top live-popout-bottom');
        main.addClass('live-popout-' + position);

        const url = (widget.length
            ? howspace.widgets.getApiUrl(widget)
            : real.baseUri + '/api/widget/' + livePopoutLayout.data('widget-type') + '/' + livePopoutLayout.data('widget-id')
        ) + '/state/position';

        real.ajax.json(url, {
            type: 'POST',
            data: JSON.stringify({position: position})
        });
    });

    livePopoutLayout.find('.full-screen-btn').on('click', () => howspace.fullscreen.open(livePopoutLayout));
    livePopoutLayout.find('.exit-full-screen-btn').on('click', () => howspace.fullscreen.close(livePopoutLayout));

    const initConfirmDeleteRecordingModal = (modal, modalOpener) => {
        modal = $(modal);
        modalOpener = $(modalOpener);

        const recordingId = modalOpener.closest('tr').data('id');
        const widget = modalOpener.closest('.widget');
        const lister = widget.find('.howspace-lister');

        modal.find('.delete-btn').on('click', () => {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/recording/' + recordingId, {
                type: 'DELETE',
                success: () => {
                    howspace.components.modal.close(modal);
                    howspace.components.lister.reload(lister);
                }
            });
        });
    };

    return {
        initView: widget => {
            howspace.widgets.live.initDrag();

            // Join button.
            widget.find('.join-btn').on('click', () => {
                howspace.widgets.live.join(widget);
            });

            // Leave button.
            widget.find('.leave-btn').on('click', () => {
                howspace.widgets.live.leave(widget);
            });

            // Show more button.
            widget.find('.show-more-btn').on('click', e => {
                const users = widget.find('.users');
                users.removeClass('limit');

                const btn = $(e.target);
                btn.addClass('d-none');
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Add breakout group button.
            widget.find('.add-group-btn').on('click', () => {
                const sortableList = widget.find('.howspace-sortable-list');
                howspace.components.sortableList.addItem(sortableList);
            });

            // Streaming URL
            widget.find('input[name="live_properties{rtmp_url}"]').on('change', e => {
                const input = $(e.target);
                const url = real.trim(input.val());

                if (howspace.form.validateUrl(url, 'rtmp')) {
                    input.removeClass('is-invalid');
                } else {
                    input.addClass('is-invalid');
                }
            });

            widget.on('click', '.publish-btn', e => {
                const btn = $(e.target);
                const tr = btn.closest('tr');
                const recordingId = tr.data('id');
                const timestamp = tr.find('time:first').text();

                const dataPayload = {
                    widget: {
                        type: 'video',
                        params: {
                            title: howspace.translate('live_recording_publish_title', {'timestamp': timestamp}),
                            description_text: { default: howspace.translate('live_recording_publish_description_text') },
                        }
                    }
                };

                const pageId = real.dom.$body.data('page-id');
                const columnId = btn.closest('.column').data('column-id');
                real.ajax.json(`${real.baseUri}/api/page/${pageId}/column/${columnId}/add-widget`, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: response => {
                        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/recording/' + recordingId + '/publish', {
                            type: 'POST',
                            data: JSON.stringify({ workspace: real.dom.$body.data('workspace-id'), video: response.widget.id }),
                        });
                    }
                });
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            // add each breakout group to the payload
            dataPayload.live_properties.breakout_groups = [];
            widget.find('.howspace-sortable-list .breakout-group:not(.deleted) input').each(function() {
                const group = real.trim($(this).val());

                if (group) {
                    dataPayload.live_properties.breakout_groups.push(group);
                }
            });

            if (dataPayload.live_properties.enable_streaming) {
                const rtmpUrl = dataPayload.live_properties.rtmp_url;

                if (!howspace.form.validateUrl(rtmpUrl, 'rtmp')) {
                    widget.find('input[name="live_properties{rtmp_url}"]').addClass('is-invalid');
                    return false;
                }
            }

            return dataPayload;
        },
        join: widget => {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/state/join', {
                type: 'POST',
                success: (response) => {
                    // Capture before initPopout() overwrites data-widget-topic
                    const previousTopic = livePopoutLayout.data('widget-topic');

                    howspace.widgets.live.initPopout(widget, response.popout_position, response.embed_code, response.live_active_title, response.live_is_locked);

                    if (response.live_previous_widget_id) {
                        if (previousTopic && previousTopic !== widget.data('topic')) {
                            real.realtime.unsubscribe(previousTopic);
                        }
                        const previousWidget = $('#widget-' + response.live_previous_widget_id);
                        if (previousWidget.length > 0) {
                            howspace.widgets.updateWidget(previousWidget, 'view');
                        }
                    }

                    howspace.activityTracker.setInMeeting(true);

                    // Unlock push sync button for all PDF widgets
                    $('.widget-pdf .push-sync-btn').removeClass('d-none');
                }
            });
        },
        leave: widget => {
            const url = (widget.length
                ? howspace.widgets.getApiUrl(widget)
                : real.baseUri + '/api/widget/' + livePopoutLayout.data('widget-type') + '/' + livePopoutLayout.data('widget-id')
            ) + '/state/leave';

            const topic = widget.length ? widget.data('topic') : livePopoutLayout.data('widget-topic');

            real.ajax.json(url, {
                type: 'POST',
                success: () => {
                    howspace.widgets.live.destroyPopout();

                    real.realtime.unsubscribe(topic);

                    // The meeting is over for the shared session — tear it down in
                    // any other tab that is showing it (or the "in another tab" notice).
                    liveTabSync.broadcastLeft();

                    // Hide push sync button for all pdf widget
                    $('.widget-pdf .push-sync-btn').addClass('d-none');

                    if (widget.length) {
                        howspace.widgets.updateWidget(widget, 'view');
                    }

                    howspace.activityTracker.setInMeeting(false);
                }
            });
        },
        initDrag: () => {
            if (dragInitialized) {
                return;
            }
            dragInitialized = true;

            const dragHandle = document.querySelector('#live-drag-handle');
            dragHandle.addEventListener("pointerdown", function () {
                drag = true;
                livePopoutLayout.addClass('resizing');
                main[0].addEventListener("pointermove", howspace.widgets.live.onPointerMove);
                main[0].addEventListener("pointerup", howspace.widgets.live.onPointerUp);
            });
            dragHandle.addEventListener("focus", function () {
               // When focused, we listen to keydown event to handle the resize
                document.addEventListener("keydown", howspace.widgets.live.onKeyDown);
            });

            dragHandle.addEventListener("focusout", function () {
                // When focus out, we stop listening to keydown event
                document.removeEventListener("keydown", howspace.widgets.live.onKeyDown);
            });
        },
        onPointerMove: e => {
            let moveY;
            if ( ! drag) {
                return
            }
            if (main.hasClass('live-popout-bottom')) {
                moveY = livePopoutLayout[0].getBoundingClientRect().bottom - e.y;
            } else {
                moveY = e.y - livePopoutLayout[0].getBoundingClientRect().top
            }
            main[0].style.setProperty('--live-popout-height', moveY + "px");
        },
        onPointerUp: () => {
            drag = false;
            livePopoutLayout.removeClass('resizing');
            main[0].removeEventListener("pointermove", howspace.widgets.live.onPointerMove);
            main[0].removeEventListener("pointerup", howspace.widgets.live.onPointerUp);
        },
        onKeyDown: e => {
            const step = 50;
            let height = livePopoutLayout.height();
            if (e.key === "ArrowUp") {
                main[0].style.setProperty('--live-popout-height', (height - step) + "px");
            } else if (e.key === "ArrowDown") {
                main[0].style.setProperty('--live-popout-height', (height + step) + "px");
            } else {
                return;
            }
            e.preventDefault();
        },
        initConfirmDeleteRecordingModal: initConfirmDeleteRecordingModal,
        initPopout: (widget, position, embedCode, title, isLocked = false) => {
            real.dom.$body.addClass('live-active');
            $('#main').addClass('live-popout-' + position);

            livePopoutLayout.find('iframe').remove();
            livePopoutLayout.dataAndAttr('widget-id', widget.data('widget-id'));
            livePopoutLayout.dataAndAttr('widget-type', widget.data('widget-type'));
            livePopoutLayout.dataAndAttr('widget-topic', widget.data('topic'));

            const webinarActions = livePopoutLayout.find('.live-popout-webinar-actions');
            webinarActions.addClass('d-none');
            webinarActions.find('.start-webinar-btn, .end-webinar-btn').addClass('d-none');

            livePopoutLayout.append(embedCode);

            const textBox = livePopoutLayout.find('.live-popout-top-strip-text-box');
            textBox.find('span').text(title);
            if (title) {
                textBox.removeClass('d-none');
            } else {
                textBox.addClass('d-none');
            }

            const liveLockedIcon = livePopoutLayout.find('.live-locked-icon');
            if (isLocked) {
                liveLockedIcon.removeClass('d-none');
            } else {
                liveLockedIcon.addClass('d-none');
            }

            livePopoutLayout.find('.live-popout-other-tab-notice').addClass('d-none');
            livePopoutLayout.removeClass('d-none');

            // This tab is now running the call; ask any other tab to step down so
            // the user only ever joins (and appears) once.
            liveTabSync.claim();
        },
        destroyPopout: () => {
            if (livePopoutLayout.length === 0) {
                // Tier 2 loads this module on every page, also on the ones that never render the popout
                // layout (login, manager, builder). Those tabs still receive the cross-tab "meeting ended"
                // message, but they have nothing to tear down.
                return;
            }

            howspace.fullscreen.close(livePopoutLayout);

            real.dom.$body.removeClass('live-active');
            $('#main').removeClass('live-popout-right live-popout-top live-popout-bottom');

            livePopoutLayout.find('iframe').remove();
            livePopoutLayout.find('.live-popout-other-tab-notice').addClass('d-none');
            livePopoutLayout.addClass('d-none');
            livePopoutLayout.removeDataAndAttr('widget-id');
            livePopoutLayout.removeDataAndAttr('widget-type');
            livePopoutLayout.removeDataAndAttr('widget-topic');

            const webinarActions = livePopoutLayout.find('.live-popout-webinar-actions');
            webinarActions.addClass('d-none');
            webinarActions.find('.start-webinar-btn, .end-webinar-btn').addClass('d-none');
        }
    };
})();
